exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".team__desktopView--1SW0T {\n  display: none;\n}\n\n.team__teamMenu--2Fdb6 {\n  padding-left: 10px;\n  border-bottom: 1px solid #3a3d40;\n}\n\n@media (min-width: 768px) {\n  .team__teamMenu--2Fdb6 {\n    padding-left: 20px;\n  }\n  .team__desktopView--1SW0T {\n    display: block;\n  }\n  .team__extraInfoCard--fUVV3 {\n    margin-top: 15px;\n  }\n}", ""]);

// exports
exports.locals = {
	"desktopView": "team__desktopView--1SW0T",
	"teamMenu": "team__teamMenu--2Fdb6",
	"extraInfoCard": "team__extraInfoCard--fUVV3"
}; 
var style = module.exports.toString();module.exports = exports.locals || { stylesheet: "" };if (!module.exports.stylesheet) { module.exports.stylesheet = style; };